import { Theme } from "@finvia/money-ui";
import styled, { css } from "styled-components";

const extraFieldWrapper = () => css`
  width: 100%;
`;

const extraFieldWrapperWithDeleteIcon = ({
  isFirstSelect,
  theme,
}: {
  isFirstSelect: boolean;
  theme: Theme;
}) =>
  !isFirstSelect &&
  css`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr ${theme.tokens.sizes.spacings.giga};
    gap: ${theme.tokens.sizes.spacings.mega};
  `;

export const RemoveIconWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding-top: ${theme.tokens.sizes.spacings.giga};
  `}
`;

export const FullRow = styled.div`
  grid-column: 1 / -1;
`;

export const ExtraFieldWrapper = styled.div<{
  isFirstSelect: boolean;
  theme: Theme;
}>(extraFieldWrapper, extraFieldWrapperWithDeleteIcon);
